module.exports = __webpack_public_path__ + "img/empty-state-revs.cbc05190.png";